module.exports = __webpack_public_path__ + "img/zadanie_wykonane.c928b223.svg";